import { useSWRConfig } from "swr";
import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { Meeting } from "../types";
import { errorHandler } from "src/hooks/errorHandler";

export function useCreateMeetings() {
  const accessToken = getUserToken();
  const { mutate, cache } = useSWRConfig();

  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return (
    meetings: {
      meetingType?: number;
      contact?: number;
      coHosts?: number[];
      overrides?: {
        duration?: number;
        dayRangeFrom?: number;
        dayRangeTo?: number;
        gap?: number;
        bufferDurationMinutes?: number;
        emailSubjectTemplate?: string;
        emailBodyTemplate?: string;
        inviteTitleTemplate?: string;
        inviteBodyTemplate?: string;
      };
      startTime?: string;
      user?: number;
      enabled?: boolean;
      meta: {
        platform: string;
        source: string;
      };
    }[],
  ): Promise<{ failures: null | any[]; instances: Meeting[] }> =>
    service
      .post(`/api/meetings/instance`)
      .set(headers)
      .send(meetings)
      .then(tokenRefreshHandler)
      .then((res: Response) => res.body)
      .then((res: any) => {
        // @ts-ignore
        const keys = cache.keys();

        // Invalidate meeting queries and force refresh.
        Array.from(keys)
          .filter((r: any) => r.includes("/api/meetings/instances"))
          .forEach((k: any) => {
            mutate(k);
          });

        return res;
      })
      .catch(errorHandler);
}
